// Dependencies
import React from 'react';
import PropTypes from 'prop-types';

// Styles
import BlogPostSidebarStyles from './blogPostSidebar.styles';
import BlogAuthorSocial from '../blogAuthorSocial/blogAuthorSocial';

// Components
import Image from '../../image/image';

export default function BlogPostSidebar({ author }) {
  const blogProfile = author?.blogProfile;
  const profilePhoto = blogProfile?.profilePhoto1 || blogProfile?.profilePhoto2;
  const firstName = author?.firstName;
  const lastName = author?.lastName;

  return (
    <BlogPostSidebarStyles>
      <div className="author">
        <div className="top">
          {profilePhoto && (
            <Image
              image={profilePhoto}
              className="profile-photo"
              filter={false}
            />
          )}
          <p className="name">
            {firstName} {lastName}
          </p>
        </div>

        <div className="bottom">
          <BlogAuthorSocial author={author} compact />
        </div>
      </div>
      <span className="separator" />
    </BlogPostSidebarStyles>
  );
}

BlogPostSidebar.propTypes = {
  author: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    blogProfile: PropTypes.shape({
      facebookProfileUrl: PropTypes.string,
      instagramProfileUrl: PropTypes.string,
      linkedinProfileUrl: PropTypes.string,
      pinterestProfileUrl: PropTypes.string,
      twitterProfileUrl: PropTypes.string,
      profilePhoto: PropTypes.shape({
        altText: PropTypes.string,
        localFile: PropTypes.shape({
          publicUrl: PropTypes.string,
          gatsbyImage: PropTypes.shape({}),
        }),
      }),
    }),
  }).isRequired,
};
